<template>
  <button
    type="button"
    class="bg-background-neutral-secondary flex w-full items-center justify-between space-x-3 rounded-2xl text-left"
    :class="{ 'duration-300 active:shadow-md': withClickAnimation }"
  >
    <span class="flex w-full items-center justify-between space-x-3">
      <span class="flex min-w-0 items-center space-x-3">
        <span
          class="bg-background-positive-muted flex h-10 w-10 items-center justify-center rounded-2xl p-[6px]"
        >
          <!-- prettier-ignore --><svg
            class="shrink-0"
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            fill="none"
          >
            <path
              fill="url(#a)"
              d="M7.6 11.6a4 4 0 0 0-4 4A2.4 2.4 0 0 0 6 18h8a2.4 2.4 0 0 0 2.4-2.4 4 4 0 0 0-4-4H7.6Z"
            />
            <path fill="#4EBC73" d="M10 2a4 4 0 1 0 0 8 4 4 0 0 0 0-8Z" />
            <defs>
              <linearGradient
                id="a"
                x1="6.136"
                x2="13.864"
                y1="19.129"
                y2="11.409"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#4EBC73" stop-opacity=".3" />
                <stop offset="1" stop-color="#4EBC73" />
              </linearGradient>
            </defs></svg
          >
        </span>
        <span class="min-w-0">
          <span
            class="text-text-neutral-primary block truncate text-base font-medium"
          >
            {{ `${passenger.last_name} ${passenger.first_name}` }}
          </span>
          <span class="text-text-neutral-tertiary block text-xs">
            {{ paxDocumentText }}
          </span>
          <!-- Доп. строки под документом (например, мильные карты). -->
          <slot name="details" />
        </span>
      </span>
      <slot name="action" />
    </span>
  </button>
</template>

<script setup lang="ts">
  import { computed } from 'vue';
  import type { Accounts } from '@aviata/platform-types';

  import { bookingPassengerLib } from '../lib';

  type PassengerData = Pick<
    Accounts.Passenger,
    'last_name' | 'first_name' | 'document_type' | 'document_number'
  >;

  // TODO: change received type's fields to camelCase, change mappings in all occurrences
  const props = withDefaults(
    defineProps<{
      passenger: PassengerData;
      withClickAnimation?: boolean;
    }>(),
    {
      withClickAnimation: true,
    },
  );

  const paxDocumentText = computed(() =>
    bookingPassengerLib.getPaxDocText(
      props.passenger.document_type,
      props.passenger.document_number,
    ),
  );
</script>
